import Vue from "vue";
//import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vuetify from "vuetify/lib";
//import Vuetify, { VCard } from "vuetify/lib";
//import { Ripple, Scroll } from "vuetify/lib/directives";
import zhHant from "vuetify/src/locale/zh-Hant";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#181C24",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        profileForm: "#FFA20A",
        blue: "#287FCE"
      },
      dark: {
        primary: "#FFA20A",
        orange: "#FEC900"
      }
    }
  },
  lang: {
    locales: { zhHant },
    current: "zh-Hant"
  }
});
